import usePrivateAxios from "@/common/api/usePrivateAxios";
import { PermissionData, PermissionResponse } from "@/common/types/permissions";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

const useEstablishmentPermission: (id: string) => UseQueryResult<PermissionData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<PermissionResponse, unknown, PermissionData>({
    queryKey: ['establishmentPermission', id],
    queryFn: () => privateAxios.get(`/establishment/permissions/${id}`),
    select: (data) => data?.data?.data
  });
};

export default useEstablishmentPermission;
